var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page_d"},[_c('video',{ref:"video",staticClass:"video_d",attrs:{"id":"preview","autoplay":"","playsinline":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }